import { NS as StandingPartitionsHeadsNS } from '../StandingPartitionsHeads/StandingPartitionsHeads';
import { NS as StandingArchNS }            from '../StandingArch/StandingArch';
import { NS as StorageNS }                 from './StandingStorage';
import ViewerComponent                     from '../../../viewer/Viewer/Viewer';

const mtx = (position : ViewerComponent.TVector3, rotation : number) => app.viewer.mtx(
	position,
	[ 1, 1, 1 ],
	rotation
);

export default function computeMatrix(this : StorageNS.Component, size : string) : ViewerComponent.TMatrix | null {
	const wdh = this.getWDH();
	const x = wdh.width;
	const y = wdh.height;
	const z = wdh.depth;
	void y;
	const surface = x * z;
	const product = app.currentProduct;
	if (!product) {
		this.component_throwUserError('No current product available in storage!');
	}
	const layoutId = this.globalLayoutId;
	if (!layoutId) {
		this.component_throwUserError('No layout used!');
	}
	const partitionsHeads = app.modules.used.find(x => x.id === 'standing-partitionsHeads');
	if (!partitionsHeads) {
		this.component_throwUserError('Partitions Heads not instanciate before storage');
	}
	const partitionHeadsComponent = <StandingPartitionsHeadsNS.Component> partitionsHeads.component;
	if (!partitionHeadsComponent) {
		this.component_throwUserError('Partitions Heads doesnt have component in storage');
	}
	const partitionsUsedWidthOnWall = partitionHeadsComponent.usedWidthOnWall;
	const arch = app.modules.used.find(x => x.id === 'standing-arch');
	if (!arch) {
		this.component_throwUserError('Partitions Heads not instanciate before storage');
	}
	const archComponent = <StandingArchNS.Component> arch.component;
	if (!archComponent) {
		this.component_throwUserError('Archs doesnt have component in storage');
	}
	const boundingBoxArch = archComponent.archDimensions;
	if (product.id === 'business') {
		if (surface > 35) {
			if(x < 4){
				const storage2x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU === 'storage2x1Classic');
				if (!storage2x1Classic) {
					this.component_throwUserError('No storage 3x1 classic found');
				}
				const boundingBox2x1Classic = storage2x1Classic.boundingBox;
				if (!boundingBox2x1Classic) {
					this.component_throwUserError('Missing bounding box for storage ');
				}
				if (layoutId === 'shape-no-wall') {
					return null;
				} else if (layoutId === 'shape-back-left') {
					if (!boundingBoxArch) {
						this.component_throwUserError('Missing bounding box for arch in storage');
					}
					this.positionStorage =
						{ start : z - boundingBoxArch.width - boundingBox2x1Classic.width, end : z - boundingBoxArch.width };
					return mtx(
						[ -x / 2, 0, -z / 2 + boundingBoxArch.width + boundingBox2x1Classic.width ],
						90
					);
				} else if (layoutId === 'shape-back') {
					this.positionStorage =
						{ start : partitionsUsedWidthOnWall, end : partitionsUsedWidthOnWall + boundingBox2x1Classic.width };
					return mtx([ -x / 2 + partitionsUsedWidthOnWall, 0, -z / 2 ], 0);
				} else if (layoutId === 'shape-back-right') {
					if (!boundingBoxArch) {
						this.component_throwUserError('Missing bounding box for arch in storage');
					}
					this.positionStorage =
						{ start : x + boundingBoxArch.width, end : x + boundingBoxArch.width + boundingBox2x1Classic.width };
					return mtx([ x / 2, 0, -z / 2 + boundingBoxArch.width ], 270);
				} else if (layoutId === 'shape-left-back-right') {
					if (!boundingBoxArch) {
						this.component_throwUserError('Missing bounding box for arch in storage');
					}
					this.positionStorage =
						{ start : z + boundingBoxArch.width, end : z + boundingBoxArch.width + boundingBox2x1Classic.width };
					return mtx([ -x / 2 + boundingBoxArch.width, 0, -z / 2 ], 0);
				} else {
					this.component_throwUserError('Unknown layoutId in storage');
				}
			}else if(z < 4){
				const storage2x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU === 'storage2x1Classic');
				if (!storage2x1Classic) {
					this.component_throwUserError('No storage 3x1 classic found');
				}
				const boundingBox2x1Classic = storage2x1Classic.boundingBox;
				if (!boundingBox2x1Classic) {
					this.component_throwUserError('Missing bounding box for storage ');
				}
				if (layoutId === 'shape-no-wall') {
					return null;
				} else if (layoutId === 'shape-back-left') {
					if (!boundingBoxArch) {
						this.component_throwUserError('Missing bounding box for arch in storage');
					}
					this.positionStorage =
						{ start : z - boundingBoxArch.width - boundingBox2x1Classic.width, end : z - boundingBoxArch.width };
					return mtx(
						[ -x / 2, 0, -z / 2 + boundingBoxArch.width + boundingBox2x1Classic.width ],
						90
					);
				} else if (layoutId === 'shape-back') {
					this.positionStorage =
						{ start : partitionsUsedWidthOnWall, end : partitionsUsedWidthOnWall + boundingBox2x1Classic.width };
					return mtx([ -x / 2 + partitionsUsedWidthOnWall, 0, -z / 2 ], 0);
				} else if (layoutId === 'shape-back-right') {
					if (!boundingBoxArch) {
						this.component_throwUserError('Missing bounding box for arch in storage');
					}
					this.positionStorage =
						{ start : x + boundingBoxArch.width, end : x + boundingBoxArch.width + boundingBox2x1Classic.width };
					return mtx([ x / 2, 0, -z / 2 + boundingBoxArch.width ], 270);
				} else if (layoutId === 'shape-left-back-right') {
					if (!boundingBoxArch) {
						this.component_throwUserError('Missing bounding box for arch in storage');
					}
					this.positionStorage =
						{ start : z + boundingBoxArch.width, end : z + boundingBoxArch.width + boundingBox2x1Classic.width };
					return mtx([ -x / 2 + boundingBoxArch.width, 0, -z / 2 ], 0);
				} else {
					this.component_throwUserError('Unknown layoutId in storage');
				}
			}else if (size === '3x1Classic') {
				const storage3x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU === 'storage3x1Classic');
				if (!storage3x1Classic) {
					this.component_throwUserError('No storage 3x1 classic found');
				}
				const boundingBox3x1Classic = storage3x1Classic.boundingBox;
				if (!boundingBox3x1Classic) {
					this.component_throwUserError('Missing bounding box for storage ');
				}
				if (layoutId === 'shape-no-wall') {
					return null;
				} else if (layoutId === 'shape-back-left') {
					if (!boundingBoxArch) {
						this.component_throwUserError('Missing bounding box for arch in storage');
					}
					this.positionStorage =
						{ start : z - boundingBoxArch.width - boundingBox3x1Classic.width, end : z - boundingBoxArch.width };
					return mtx(
						[ -x / 2, 0, -z / 2 + boundingBoxArch.width + boundingBox3x1Classic.width ],
						90
					);
				} else if (layoutId === 'shape-back') {
					this.positionStorage =
						{ start : partitionsUsedWidthOnWall, end : partitionsUsedWidthOnWall + boundingBox3x1Classic.width };
					return mtx([ -x / 2 + partitionsUsedWidthOnWall, 0, -z / 2 ], 0);
				} else if (layoutId === 'shape-back-right') {
					if (!boundingBoxArch) {
						this.component_throwUserError('Missing bounding box for arch in storage');
					}
					this.positionStorage =
						{ start : x + boundingBoxArch.width, end : x + boundingBoxArch.width + boundingBox3x1Classic.width };
					return mtx([ x / 2, 0, -z / 2 + boundingBoxArch.width ], 270);
				} else if (layoutId === 'shape-left-back-right') {
					if (!boundingBoxArch) {
						this.component_throwUserError('Missing bounding box for arch in storage');
					}
					this.positionStorage =
						{ start : z + boundingBoxArch.width, end : z + boundingBoxArch.width + boundingBox3x1Classic.width };
					return mtx([ -x / 2 + boundingBoxArch.width, 0, -z / 2 ], 0);
				} else {
					this.component_throwUserError('Unknown layoutId in storage');
				}
			} else {
				return null;
			}
		} else if (surface > 25) {
			if (size === '2x1Classic') {
				const storage2x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage2x1Classic');
				if (!storage2x1Classic) {
					this.component_throwUserError('No storage 2x1 classic found');
				}
				const boundingBox2x1Classic = storage2x1Classic.boundingBox;
				if (!boundingBox2x1Classic) {
					this.component_throwUserError('Missing bounding box for storage ');
				}
				if (layoutId === 'shape-no-wall') {
					return null;
				} else if (layoutId === 'shape-back-left') {
					if (!boundingBoxArch) {
						this.component_throwUserError('Missing bounding box for arch in storage');
					}
					this.positionStorage =
						{ start : z - boundingBoxArch.width - boundingBox2x1Classic.width, end : z - boundingBoxArch.width };
					return mtx(
						[ -x / 2, 0, -z / 2 + boundingBoxArch.width + boundingBox2x1Classic.width ],
						90
					);
				} else if (layoutId === 'shape-back') {
					this.positionStorage =
						{ start : partitionsUsedWidthOnWall, end : partitionsUsedWidthOnWall + boundingBox2x1Classic.width };
					return mtx([ -x / 2 + partitionsUsedWidthOnWall, 0, -z / 2 ], 0);
				} else if (layoutId === 'shape-back-right') {
					if (!boundingBoxArch) {
						this.component_throwUserError('Missing bounding box for arch in storage');
					}
					this.positionStorage =
						{ start : x + boundingBoxArch.width, end : x + boundingBoxArch.width + boundingBox2x1Classic.width };
					return mtx([ x / 2, 0, -z / 2 + boundingBoxArch.width ], 270);
				} else if (layoutId === 'shape-left-back-right') {
					if (!boundingBoxArch) {
						this.component_throwUserError('Missing bounding box for arch in storage');
					}
					this.positionStorage =
						{ start : z + boundingBoxArch.width, end : z + boundingBoxArch.width + boundingBox2x1Classic.width };
					return mtx([ -x / 2 + boundingBoxArch.width, 0, -z / 2 ], 0);
				} else {
					this.component_throwUserError('Unknown layoutId in storage');
				}
			} else {
				return null;
			}
		} else if (surface > 11) {
			if (size === '1x1Classic') {
				const storage1x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU === 'storage1x1Classic');
				if (!storage1x1Classic) {
					this.component_throwUserError('No storage 1x1 classic found');
				}
				const boundingBox1x1Classic = storage1x1Classic.boundingBox;
				if (!boundingBox1x1Classic) {
					this.component_throwUserError('Missing bounding box for storage ');
				}
				if (layoutId === 'shape-no-wall') {
					return null;
				} else if (layoutId === 'shape-back-left') {
					if (!boundingBoxArch) {
						this.component_throwUserError('Missing bounding box for arch in storage');
					}
					this.positionStorage =
						{ start : z - boundingBoxArch.width - boundingBox1x1Classic.width, end : z - boundingBoxArch.width };
					return mtx(
						[ -x / 2, 0, -z / 2 + boundingBoxArch.width + boundingBox1x1Classic.width ],
						90
					);
				} else if (layoutId === 'shape-back') {
					this.positionStorage =
						{ start : partitionsUsedWidthOnWall, end : partitionsUsedWidthOnWall + boundingBox1x1Classic.width };
					return mtx([ -x / 2 + partitionsUsedWidthOnWall, 0, -z / 2 ], 0);
				} else if (layoutId === 'shape-back-right') {
					if (!boundingBoxArch) {
						this.component_throwUserError('Missing bounding box for arch in storage');
					}
					this.positionStorage =
						{ start : x + boundingBoxArch.width, end : x + boundingBoxArch.width + boundingBox1x1Classic.width };
					return mtx([ x / 2, 0, -z / 2 + boundingBoxArch.width ], 270);
				} else if (layoutId === 'shape-left-back-right') {
					if (!boundingBoxArch) {
						this.component_throwUserError('Missing bounding box for arch in storage');
					}
					this.positionStorage =
						{ start : z + boundingBoxArch.width, end : z + boundingBoxArch.width + boundingBox1x1Classic.width };
					return mtx([ -x / 2 + boundingBoxArch.width, 0, -z / 2 ], 0);
				} else {
					this.component_throwUserError('Unknown layoutId in storage');
				}
			} else {
				return null;
			}
		} else {
			return null;
		}
	} else if (product.id === 'confort') {
		if (surface > 24) {
			if(x < 4){
				const storage2x1CornerLeft = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage2x1CornerLeft');
				const storage3x1CornerLeft = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage3x1CornerLeft');
				const storage2x1Side = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage2x1Side');
				if (!storage2x1CornerLeft || !storage2x1Side || !storage3x1CornerLeft) {
					this.component_throwUserError('No storage 3x1 classic found');
				}
				const boundingBox2x1CornerLeft = storage2x1CornerLeft.boundingBox;
				const boundingBox3x1CornerLeft = storage3x1CornerLeft.boundingBox;
				const boundingBox2x1Side = storage2x1Side.boundingBox;
				if (!boundingBox2x1CornerLeft || !boundingBox2x1Side || !boundingBox3x1CornerLeft) {
					this.component_throwUserError('Missing bounding box for storage ');
				}
				if (layoutId === 'shape-no-wall') {
					return null;
				} else if (layoutId === 'shape-back-left') {
					if (size === '2x1CornerLeft') {
						this.positionStorage = { start : z - boundingBox2x1CornerLeft.width, end : z + 3 };
						return mtx([ -x / 2, 0, -z / 2 + boundingBox2x1CornerLeft.width ], 90);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-back') {
					if (size === '2x1Side') {
						this.positionStorage = { start : 0, end : 3 };
						return mtx([ -x / 2, 0, -z / 2 + boundingBox2x1Side.width ], 90);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-back-right') {
					if (size === '3x1CornerLeft') {
						this.positionStorage = { start : x - boundingBox3x1CornerLeft.width, end : x + 3 };
						return mtx([ x / 2 - boundingBox3x1CornerLeft.width, 0, -z / 2 ], 0);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-left-back-right') {
					if (size === '2x1CornerLeft') {
						this.positionStorage = { start : z - boundingBox2x1CornerLeft.width, end : z + 3 };
						return mtx([ -x / 2, 0, -z / 2 + boundingBox2x1CornerLeft.width ], 90);
					} else {
						return null;
					}
				} else {
					this.component_throwUserError('Unknown layoutId in storage');
				}
			}else if(z < 4 && layoutId === 'shape-back-right'){
				const storage2x1CornerLeft = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage2x1CornerLeft');
				if (!storage2x1CornerLeft) {
					this.component_throwUserError('No storage 3x1 classic found');
				}
				const boundingBox2x1CornerLeft = storage2x1CornerLeft.boundingBox;
				if (!boundingBox2x1CornerLeft) {
					this.component_throwUserError('Missing bounding box for storage ');
				}
				if (size === '2x1CornerLeft') {
					this.positionStorage = { start : x - boundingBox2x1CornerLeft.width, end : x + 3 };
					return mtx([ x / 2 - boundingBox2x1CornerLeft.width, 0, -z / 2 ], 0);
				} else {
					return null;
				}
			}else if (size === '3x1CornerLeft' || size === '3x1Side') {
				const storage3x1CornerLeft = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage3x1CornerLeft');
				const storage3x1Side = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage3x1Side');
				if (!storage3x1CornerLeft || !storage3x1Side) {
					this.component_throwUserError('No storage 3x1 classic found');
				}
				const boundingBox3x1CornerLeft = storage3x1CornerLeft.boundingBox;
				const boundingBox3x1Side = storage3x1Side.boundingBox;
				if (!boundingBox3x1CornerLeft || !boundingBox3x1Side) {
					this.component_throwUserError('Missing bounding box for storage ');
				}
				if (layoutId === 'shape-no-wall') {
					return null;
				} else if (layoutId === 'shape-back-left') {
					if (size === '3x1CornerLeft') {
						this.positionStorage = { start : z - boundingBox3x1CornerLeft.width, end : z + 3 };
						return mtx([ -x / 2, 0, -z / 2 + boundingBox3x1CornerLeft.width ], 90);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-back') {
					if (size === '3x1Side') {
						this.positionStorage = { start : 0, end : 3 };
						return mtx([ -x / 2, 0, -z / 2 + boundingBox3x1Side.width ], 90);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-back-right') {
					if (size === '3x1CornerLeft') {
						this.positionStorage = { start : x - boundingBox3x1CornerLeft.width, end : x + 3 };
						return mtx([ x / 2 - boundingBox3x1CornerLeft.width, 0, -z / 2 ], 0);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-left-back-right') {
					if (size === '3x1CornerLeft') {
						this.positionStorage = { start : z - boundingBox3x1CornerLeft.width, end : z + 3 };
						return mtx([ -x / 2, 0, -z / 2 + boundingBox3x1CornerLeft.width ], 90);
					} else {
						return null;
					}
				} else {
					this.component_throwUserError('Unknown layoutId in storage');
				}
			} else {
				return null;
			}
		} else if (surface > 17) {
			if (size === '2x1CornerLeft' || size === '2x1Side') {
				const storage2x1CornerLeft = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage2x1CornerLeft');
				const storage2x1Side = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage2x1Side');
				if (!storage2x1CornerLeft || !storage2x1Side) {
					this.component_throwUserError('No storage 2x1 classic found');
				}
				const boundingBox2x1CornerLeft = storage2x1CornerLeft.boundingBox;
				const boundingBox2x1Side = storage2x1Side.boundingBox;
				if (!boundingBox2x1CornerLeft || !boundingBox2x1Side) {
					this.component_throwUserError('Missing bounding box for storage ');
				}
				if (layoutId === 'shape-no-wall') {
					return null;
				} else if (layoutId === 'shape-back-left') {
					if (size === '2x1CornerLeft') {
						this.positionStorage = { start : z - boundingBox2x1CornerLeft.width, end : z + 2 };
						return mtx([ -x / 2, 0, -z / 2 + boundingBox2x1CornerLeft.width ], 90);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-back') {
					if (size === '2x1Side') {
						this.positionStorage = { start : 0, end : 2 };
						return mtx([ -x / 2, 0, -z / 2 + boundingBox2x1Side.width ], 90);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-back-right') {
					if (size === '2x1CornerLeft') {
						this.positionStorage = { start : x - boundingBox2x1CornerLeft.width, end : x + 2 };
						return mtx([ x / 2 - boundingBox2x1CornerLeft.width, 0, -z / 2 ], 0);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-left-back-right') {
					if (size === '2x1CornerLeft') {
						this.positionStorage = { start : z - boundingBox2x1CornerLeft.width, end : z + 3 };
						return mtx([ -x / 2, 0, -z / 2 + boundingBox2x1CornerLeft.width ], 90);
					} else {
						return null;
					}
				} else {
					this.component_throwUserError('Unknown layoutId in storage');
				}
			} else {
				return null;
			}
		} else {
			return null;
		}
	} else if (product.id === 'prestige') {
		if (surface > 24) {
			if(z < 4){
				if(layoutId === 'shape-back-left'){
					if (size === '2x1CornerRight') {
						const storage2x1CornerRight = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage2x1CornerRight');
						if (!storage2x1CornerRight) {
							this.component_throwUserError('No storage 2x1 Corner Left found');
						}
						const boundingBox2x1CornerRight = storage2x1CornerRight.boundingBox;
						if (!boundingBox2x1CornerRight) {
							this.component_throwUserError('Missing bounding box for storage ');
						}
						this.positionStorage = { start : z - 3, end : z + boundingBox2x1CornerRight.width };
						return mtx([ -x / 2, 0, -z / 2 ], 0);
					} else {
						return null;
					}
				}else if(layoutId === 'shape-back'){
					if (size === '2x1Classic') {
						const storage2x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage2x1Classic');
						if (!storage2x1Classic) {
							this.component_throwUserError('No storage 3x1 Corner Left found');
						}
						const boundingBox2x1Classic = storage2x1Classic.boundingBox;
						if (!boundingBox2x1Classic) {
							this.component_throwUserError('Missing bounding box for storage ');
						}
						this.positionStorage = { start : 0, end : boundingBox2x1Classic.width };
						return mtx([ -x / 2, 0, -z / 2 ], 0);
					} else {
						return null;
					}
				}else if(layoutId === 'shape-back-right'){
					if (size === '2x1CornerLeft') {
						const storage2x1CornerLeft = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage2x1CornerLeft');
						if (!storage2x1CornerLeft) {
							this.component_throwUserError('No storage 3x1 Corner Left found');
						}
						const boundingBox2x1CornerLeft = storage2x1CornerLeft.boundingBox;
						if (!boundingBox2x1CornerLeft) {
							this.component_throwUserError('Missing bounding box for storage ');
						}
						this.positionStorage = { start : x - boundingBox2x1CornerLeft.width, end : x + 3 };
						return mtx([ x / 2 - boundingBox2x1CornerLeft.width, 0, -z / 2 ], 0);
					} else {
						return null;
					}
				}else if(layoutId === 'shape-left-back-right'){
					if (size === '2x1Classic') {
						if (!boundingBoxArch) {
							this.component_throwUserError('Missing bounding box for arch in storage');
						}
						const storage2x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage2x1Classic');
						if (!storage2x1Classic) {
							this.component_throwUserError('No storage 3x1 Corner Left found');
						}
						const boundingBox2x1Classic = storage2x1Classic.boundingBox;
						if (!boundingBox2x1Classic) {
							this.component_throwUserError('Missing bounding box for storage ');
						}
						this.positionStorage =
							{ start : z + x - boundingBoxArch.width, end : z + x - boundingBoxArch.width + boundingBox2x1Classic.width };
						return mtx([ -x / 2 + boundingBoxArch.width, 0, -z / 2 ], 0);
					} else {
						return null;
					}
				}
				return null;
			}else if (size === '3x1Classic' || size === '3x1CornerLeft' || size === '3x1CornerRight') {
				if (layoutId === 'shape-no-wall') {
					return null;
				} else if (layoutId === 'shape-back-left') {
					if (size === '3x1CornerRight') {
						const storage3x1CornerRight = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU === 'storage3x1CornerRight');
						if (!storage3x1CornerRight) {
							this.component_throwUserError('No storage 3x1 Corner Left found');
						}
						const boundingBox3x1CornerRight = storage3x1CornerRight.boundingBox;
						if (!boundingBox3x1CornerRight) {
							this.component_throwUserError('Missing bounding box for storage ');
						}
						this.positionStorage = { start : z - 3, end : z + boundingBox3x1CornerRight.width };
						return mtx([ -x / 2, 0, -z / 2 ], 0);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-back') {
					if (size === '3x1Classic') {
						const storage3x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage3x1Classic');
						if (!storage3x1Classic) {
							this.component_throwUserError('No storage 3x1 Corner Left found');
						}
						const boundingBox3x1Classic = storage3x1Classic.boundingBox;
						if (!boundingBox3x1Classic) {
							this.component_throwUserError('Missing bounding box for storage ');
						}
						this.positionStorage = { start : 0, end : boundingBox3x1Classic.width };
						return mtx([ -x / 2, 0, -z / 2 ], 0);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-back-right') {
					if (size === '3x1CornerLeft') {
						const storage3x1CornerLeft = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage3x1CornerLeft');
						if (!storage3x1CornerLeft) {
							this.component_throwUserError('No storage 3x1 Corner Left found');
						}
						const boundingBox3x1CornerLeft = storage3x1CornerLeft.boundingBox;
						if (!boundingBox3x1CornerLeft) {
							this.component_throwUserError('Missing bounding box for storage ');
						}
						this.positionStorage = { start : x - boundingBox3x1CornerLeft.width, end : x + 3 };
						return mtx([ x / 2 - boundingBox3x1CornerLeft.width, 0, -z / 2 ], 0);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-left-back-right') {
					if (size === '3x1Classic') {
						if (!boundingBoxArch) {
							this.component_throwUserError('Missing bounding box for arch in storage');
						}
						const storage3x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage3x1Classic');
						if (!storage3x1Classic) {
							this.component_throwUserError('No storage 3x1 Corner Left found');
						}
						const boundingBox3x1Classic = storage3x1Classic.boundingBox;
						if (!boundingBox3x1Classic) {
							this.component_throwUserError('Missing bounding box for storage ');
						}
						this.positionStorage =
							{ start : z + x - boundingBoxArch.width, end : z + x - boundingBoxArch.width + boundingBox3x1Classic.width };
						return mtx([ -x / 2 + boundingBoxArch.width, 0, -z / 2 ], 0);
					} else {
						return null;
					}
				} else {
					this.component_throwUserError('Unknown layoutId in storage');
				}
			} else {
				return null;
			}
		} else if (surface > 17) {
			if (size === '2x1Classic' || size === '2x1CornerLeft' || size === '2x1CornerRight') {
				if (layoutId === 'shape-no-wall') {
					return null;
				} else if (layoutId === 'shape-back-left') {
					if (size === '2x1CornerRight') {
						const storage2x1CornerRight = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage2x1CornerRight');
						if (!storage2x1CornerRight) {
							this.component_throwUserError('No storage 2x1 Corner Left found');
						}
						const boundingBox2x1CornerRight = storage2x1CornerRight.boundingBox;
						if (!boundingBox2x1CornerRight) {
							this.component_throwUserError('Missing bounding box for storage ');
						}
						this.positionStorage = { start : z - 3, end : z + boundingBox2x1CornerRight.width };
						return mtx([ -x / 2, 0, -z / 2 ], 0);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-back') {
					if (size === '2x1Classic') {
						const storage2x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage2x1Classic');
						if (!storage2x1Classic) {
							this.component_throwUserError('No storage 3x1 Corner Left found');
						}
						const boundingBox2x1Classic = storage2x1Classic.boundingBox;
						if (!boundingBox2x1Classic) {
							this.component_throwUserError('Missing bounding box for storage ');
						}
						this.positionStorage = { start : 0, end : boundingBox2x1Classic.width };
						return mtx([ -x / 2, 0, -z / 2 ], 0);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-back-right') {
					if (size === '2x1CornerLeft') {
						const storage2x1CornerLeft = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage2x1CornerLeft');
						if (!storage2x1CornerLeft) {
							this.component_throwUserError('No storage 2x1 corner left found');
						}
						const boundingBox2x1CornerLeft = storage2x1CornerLeft.boundingBox;
						if (!boundingBox2x1CornerLeft) {
							this.component_throwUserError('Missing bounding box for storage ');
						}
						this.positionStorage = { start : x - boundingBox2x1CornerLeft.width, end : x + 3 };
						return mtx([ x / 2 - boundingBox2x1CornerLeft.width, 0, -z / 2 ], 0);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-left-back-right') {
					if (size === '2x1Classic') {
						if (!boundingBoxArch) {
							this.component_throwUserError('Missing bounding box for arch in storage');
						}
						const storage2x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage2x1Classic');
						if (!storage2x1Classic) {
							this.component_throwUserError('No storage 3x1 Corner Left found');
						}
						const boundingBox2x1Classic = storage2x1Classic.boundingBox;
						if (!boundingBox2x1Classic) {
							this.component_throwUserError('Missing bounding box for storage ');
						}
						this.positionStorage =
							{ start : z + x - boundingBoxArch.width, end : z + x - boundingBoxArch.width + boundingBox2x1Classic.width };
						return mtx([ -x / 2 + boundingBoxArch.width, 0, -z / 2 ], 0);
					} else {
						return null;
					}
				} else {
					this.component_throwUserError('Unknown layoutId in storage');
				}
			} else {
				return null;
			}
		} else {
			return null;
		}
	} else if (product.id === 'siae') {
		if (surface > 30) {
			if (size === '3x1CornerLeft' || size === '3x1CornerRight' || size === '3x1Classic' || size === 'lighting') {
				const storage3x1CornerLeft = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage3x1CornerLeft');
				if (!storage3x1CornerLeft) {
					this.component_throwUserError('No storage 3x1 corner left found');
				}
				const boundingBox3x1CornerLeft = storage3x1CornerLeft.boundingBox;
				if (!boundingBox3x1CornerLeft) {
					this.component_throwUserError('Missing bounding box for storage ');
				}
				const storage3x1CornerRight = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage3x1CornerRight');
				if (!storage3x1CornerRight) {
					this.component_throwUserError('No storage 3x1 corner left found');
				}
				const boundingBox3x1CornerRight = storage3x1CornerRight.boundingBox;
				if (!boundingBox3x1CornerRight) {
					this.component_throwUserError('Missing bounding box for storage ');
				}
				const storage3x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage3x1Classic');
				if (!storage3x1Classic) {
					this.component_throwUserError('No storage 3x1 corner left found');
				}
				const boundingBox3x1Classic = storage3x1Classic.boundingBox;
				if (!boundingBox3x1Classic) {
					this.component_throwUserError('Missing bounding box for storage ');
				}
				if (layoutId === 'shape-no-wall') {
					return null;
				} else if (layoutId === 'shape-back-left') {
					if (size === '3x1CornerRight') {
						this.positionStorage = { start : z - 3, end : z + boundingBox3x1CornerRight.width };
						return mtx([ -x / 2, 0, -z / 2 ], 0);
					} else if (size === 'lighting') {
						return mtx([
							-x / 2 + boundingBox3x1CornerRight.width,
							0,
							-z / 2 + boundingBox3x1CornerRight.depth / 2
						], 90);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-back') {
					if (size === '3x1Classic') {
						this.positionStorage =
							{ start : partitionsUsedWidthOnWall, end : partitionsUsedWidthOnWall + boundingBox3x1Classic.width };
						return mtx([ -x / 2 + partitionsUsedWidthOnWall, 0, -z / 2 ], 0);
					} else if (size === 'lighting') {
						return mtx([
							-x / 2 + boundingBox3x1Classic.width + partitionsUsedWidthOnWall,
							0,
							-z / 2 + boundingBox3x1Classic.depth / 2
						], 90);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-back-right') {
					if (size === '3x1CornerLeft') {
						this.positionStorage = { start : x - boundingBox3x1CornerLeft.width, end : x + 3 };
						return mtx([ x / 2 - boundingBox3x1CornerLeft.width, 0, -z / 2 ], 0);
					} else if (size === 'lighting') {
						return mtx([
							x / 2 - boundingBox3x1CornerLeft.width,
							0,
							-z / 2 + boundingBox3x1CornerLeft.depth / 2
						], 270);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-left-back-right') {
					if (x < 3.75) {
						return null;
					}
					if (size === '3x1CornerLeft') {
						this.positionStorage = { start : z - boundingBox3x1CornerLeft.width, end : z + 3 };
						return mtx([ -x / 2, 0, -z / 2 + boundingBox3x1CornerLeft.width ], 90);
					} else if (size === 'lighting') {
						return mtx([
							-x / 2 + boundingBox3x1CornerLeft.depth / 2,
							0,
							-z / 2 + boundingBox3x1CornerLeft.width
						], 0);
					} else {
						return null;
					}
				} else {
					this.component_throwUserError('Unknown layoutId in storage');
				}
			} else {
				return null;
			}
		} else if (surface > 24) {
			if (size === '2x1Classic' || size === '2x1CornerRight' || size === '2x1CornerLeft' || size === 'lighting') {
				const storage2x1CornerLeft = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage2x1CornerLeft');
				if (!storage2x1CornerLeft) {
					this.component_throwUserError('No storage 2x1 corner left found');
				}
				const boundingBox2x1CornerLeft = storage2x1CornerLeft.boundingBox;
				if (!boundingBox2x1CornerLeft) {
					this.component_throwUserError('Missing bounding box for storage ');
				}
				const storage2x1CornerRight = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage2x1CornerRight');
				if (!storage2x1CornerRight) {
					this.component_throwUserError('No storage 2x1 corner left found');
				}
				const boundingBox2x1CornerRight = storage2x1CornerRight.boundingBox;
				if (!boundingBox2x1CornerRight) {
					this.component_throwUserError('Missing bounding box for storage ');
				}
				const storage2x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage2x1Classic');
				if (!storage2x1Classic) {
					this.component_throwUserError('No storage 2x1 corner left found');
				}
				const boundingBox2x1Classic = storage2x1Classic.boundingBox;
				if (!boundingBox2x1Classic) {
					this.component_throwUserError('Missing bounding box for storage ');
				}
				if (layoutId === 'shape-no-wall') {
					return null;
				} else if (layoutId === 'shape-back-left') {
					if (size === '2x1CornerRight') {
						this.positionStorage = { start : z - 2, end : z + boundingBox2x1CornerRight.width };
						return mtx([ -x / 2, 0, -z / 2 ], 0);
					} else if (size === 'lighting') {
						return mtx([
							-x / 2 + boundingBox2x1CornerRight.width,
							0,
							-z / 2 + boundingBox2x1CornerRight.depth / 2
						], 90);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-back') {
					if (size === '2x1Classic') {
						this.positionStorage =
							{ start : partitionsUsedWidthOnWall, end : partitionsUsedWidthOnWall + boundingBox2x1Classic.width };
						return mtx([ -x / 2 + partitionsUsedWidthOnWall, 0, -z / 2 ], 0);
					} else if (size === 'lighting') {
						return mtx([
							-x / 2 + boundingBox2x1Classic.width + partitionsUsedWidthOnWall,
							0,
							-z / 2 + boundingBox2x1Classic.depth / 2
						], 90);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-back-right') {
					if (size === '2x1CornerLeft') {
						this.positionStorage = { start : x - boundingBox2x1CornerLeft.width, end : x + 2 };
						return mtx([ x / 2 - boundingBox2x1CornerLeft.width, 0, -z / 2 ], 0);
					} else if (size === 'lighting') {
						return mtx([
							x / 2 - boundingBox2x1CornerLeft.width,
							0,
							-z / 2 + boundingBox2x1CornerLeft.depth / 2
						], 270);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-left-back-right') {
					if (size === '2x1CornerLeft') {
						this.positionStorage = { start : z - boundingBox2x1CornerLeft.width, end : z + 2 };
						return mtx([ -x / 2, 0, -z / 2 + boundingBox2x1CornerLeft.width ], 90);
					} else if (size === 'lighting') {
						return mtx([
							-x / 2 + boundingBox2x1CornerLeft.depth / 2,
							0,
							-z / 2 + boundingBox2x1CornerLeft.width
						], 0);
					} else {
						return null;
					}
				} else {
					this.component_throwUserError('Unknown layoutId in storage');
				}
			} else {
				return null;
			}
		} else if (surface > 11) {
			if (size === '1x1Classic' || size === '1x1CornerRight' || size === '1x1CornerLeft' || size === 'lighting') {
				const storage1x1CornerLeft = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage1x1CornerLeft');
				if (!storage1x1CornerLeft) {
					this.component_throwUserError('No storage 1x1 corner left found');
				}
				const boundingBox1x1CornerLeft = storage1x1CornerLeft.boundingBox;
				if (!boundingBox1x1CornerLeft) {
					this.component_throwUserError('Missing bounding box for storage ');
				}
				const storage1x1CornerRight = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage1x1CornerRight');
				if (!storage1x1CornerRight) {
					this.component_throwUserError('No storage 1x1 corner left found');
				}
				const boundingBox1x1CornerRight = storage1x1CornerRight.boundingBox;
				if (!boundingBox1x1CornerRight) {
					this.component_throwUserError('Missing bounding box for storage ');
				}
				const storage1x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage1x1Classic');
				if (!storage1x1Classic) {
					this.component_throwUserError('No storage 1x1 corner left found');
				}
				const boundingBox1x1Classic = storage1x1Classic.boundingBox;
				if (!boundingBox1x1Classic) {
					this.component_throwUserError('Missing bounding box for storage ');
				}
				if (layoutId === 'shape-no-wall') {
					return null;
				} else if (layoutId === 'shape-back-left') {
					if (size === '1x1CornerRight') {
						this.positionStorage = { start : z - 1, end : z + boundingBox1x1CornerRight.width };
						return mtx([ -x / 2, 0, -z / 2 ], 0);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-back') {
					if (size === '1x1Classic') {
						this.positionStorage =
							{ start : partitionsUsedWidthOnWall, end : partitionsUsedWidthOnWall + boundingBox1x1Classic.width };
						return mtx([ -x / 2 + partitionsUsedWidthOnWall, 0, -z / 2 ], 0);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-back-right') {
					if (size === '1x1CornerLeft') {
						this.positionStorage = { start : x - boundingBox1x1CornerLeft.width, end : x + 1 };
						return mtx([ x / 2 - boundingBox1x1CornerLeft.width, 0, -z / 2 ], 0);
					} else {
						return null;
					}
				} else if (layoutId === 'shape-left-back-right') {
					if (size === '1x1CornerRight') {
						this.positionStorage = { start : z - 1, end : z + boundingBox1x1CornerRight.width };
						return mtx([ -x / 2, 0, -z / 2 ], 0);
					} else {
						return null;
					}
				} else {
					this.component_throwUserError('Unknown layoutId in storage');
				}
			} else {
				return null;
			}
		} else {
			return null;
		}
	} else {
		this.component_throwUserError('Unknown product name in storage');
	}
};
